<template>
  <v-container fluid class="help-center">
    <div class="help-center__heading">
      <div>
        <div class="help-center__eyebrow">Guides and explanations</div>
        <h1>Help Center</h1>
        <p>Learn how Taleem administration, academic setup, grades, and report cards work together.</p>
      </div>
    </div>

    <v-text-field
      v-model="search"
      outlined
      dense
      clearable
      hide-details
      prepend-inner-icon="mdi-magnify"
      placeholder="Search help topics"
      class="help-center__search"
    />

    <v-row>
      <v-col cols="12" md="4" lg="3">
        <v-card elevation="0" class="help-center__topics">
          <v-list nav dense>
            <v-list-item
              v-for="item in filteredTopics"
              :key="item.id"
              :class="{ 'v-list-item--active': item.id === selectedTopic.id }"
              @click="selectTopic(item.id)"
            >
              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
                <v-list-item-subtitle>{{ item.summary }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <div v-if="!filteredTopics.length" class="help-center__empty">No matching help topics.</div>
        </v-card>
      </v-col>

      <v-col cols="12" md="8" lg="9">
        <v-card elevation="0" class="help-center__article">
          <HelpArticle :topic="selectedTopic" @select-topic="selectTopic" />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import HelpArticle from "@/modules/Help/components/HelpArticle.vue"
import { helpTopics, getHelpTopic } from "@/modules/Help/helpTopics"

export default {
  name: "help-center",
  components: { HelpArticle },
  data() {
    return {
      search: "",
      selectedTopic: getHelpTopic(this.$route.query.topic),
    }
  },
  computed: {
    filteredTopics() {
      const query = String(this.search || "").trim().toLowerCase()
      if (!query) return helpTopics
      return helpTopics.filter(topic => [
        topic.title,
        topic.summary,
        ...(topic.keywords || []),
        ...(topic.sections || []).reduce((text, section) => text.concat(
          section.title,
          ...(section.body || []),
          ...(section.bullets || []),
          ...(section.steps || []),
          section.note || ""
        ), []),
      ].join(" ").toLowerCase().includes(query))
    },
  },
  watch: {
    "$route.query.topic"(topicId) {
      this.selectedTopic = getHelpTopic(topicId)
    },
  },
  methods: {
    selectTopic(topicId) {
      this.selectedTopic = getHelpTopic(topicId)
      this.$router.replace({ name: "help-center", query: { topic: this.selectedTopic.id } }).catch(error => {
        if (error.name !== "NavigationDuplicated") console.error(error)
      })
    },
  },
}
</script>

<style scoped>
.help-center { max-width: 1320px; padding: 28px 30px 52px; }
.help-center__heading { display: flex; align-items: flex-start; justify-content: space-between; margin-bottom: 20px; }
.help-center__eyebrow { color: #2e7d32; font-size: 11px; font-weight: 700; letter-spacing: .08em; text-transform: uppercase; }
.help-center__heading h1 { margin: 3px 0 5px; color: #253229; font-size: 30px; font-weight: 600; }
.help-center__heading p { margin: 0; color: #667269; font-size: 14px; }
.help-center__search { max-width: 640px; margin-bottom: 22px; }
.help-center__topics, .help-center__article { border: 1px solid #e4eae5; border-radius: 12px; }
.help-center__topics { overflow: hidden; }
.help-center__topics .v-list { padding: 8px; }
.help-center__topics .v-list-item { min-height: 58px; margin-bottom: 3px; border-radius: 8px; }
.help-center__topics .v-list-item--active { color: #2e7d32; background: #eaf5eb; }
.help-center__topics .v-list-item__title { font-size: 13px; font-weight: 600; }
.help-center__topics .v-list-item__subtitle { margin-top: 3px; font-size: 11px; line-height: 1.35; white-space: normal; }
.help-center__empty { padding: 24px; color: #667269; font-size: 13px; text-align: center; }
.help-center__article { min-height: 560px; padding: 28px 30px; }
@media (max-width: 959px) {
  .help-center { padding: 22px 18px 44px; }
  .help-center__article { min-height: 0; padding: 22px 20px; }
}
</style>
